import styled from "styled-components";

export const MyP = styled.p`
    color: ${props => props.color};
    font-family: Roboto;
`